import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileService } from 'src/app/api/file.service';
import { Alumno } from 'src/app/model/alumno';
import { Annotation } from 'src/app/model/annotation';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-annotation-list-dialog',
  templateUrl: './annotation-list-dialog.component.html',
  styleUrls: ['./annotation-list-dialog.component.css']
})
export class AnnotationListDialogComponent implements OnInit {
  public filterName: string = 'Neg';
  // public annotationsFiltred: Annotation[];
 public photosUrlService: string = `${environment.apiUrl}/api/lichan/alumno/1.0/foto`;
 

  constructor(public dialogRef: MatDialogRef<AnnotationListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: AnnotationListDialogParameters, private fileService: FileService) { }

  ngOnInit(): void {
  }

  public filterAnnotations(annotations: Annotation[]): Annotation[] {
    // if (this.filterName == 'All') return annotations;

    switch (this.filterName) {
      case 'All':
        return annotations;
      case 'Eve':
        return annotations.filter(a => a.annotationType.event);
      case 'Pos':
        return annotations.filter(a => !a.annotationType.negative && !a.annotationType.event);
      case 'Neg':
        return annotations.filter(a => a.annotationType.negative);
      default:
        break;
    }
    return [];
  }

  public printReport(): void {
    console.log('Print report');
    this.fileService.downloadExternal('annotations', this.dialogData.student.id, this.dialogData.student.courseDto.id, null, 'informe-comportamiento.pdf');

  }


}

export class AnnotationListDialogParameters {
  dialogTitle: string;
  student: Alumno;
  annotations: Annotation[];
  showPrintSummaryButton: boolean;
}